import { useEffect, useState } from 'react'
import ReactLoading from 'react-loading'
import styled from 'styled-components'

import { palette, fonts, mediaQueries, shadows } from '../../styles/variables'
import Icon, { ArrowLabel } from '../../components/icon/Icon'
import Tooltip from '../../components/tooltip/Tooltip'
import { getLanguageCode, translate } from '../../utils/translation'
import arrowRight from '../../styles/assets/arrows/orange_arrow_right.svg'
import arrowRightGray from '../../styles/assets/arrows/arrow_right_gray.svg'
import checkGreenIcon from '../../styles/assets/circle_check_green_fill.svg'
import gaIcon from '../../styles/assets/dashboard/gAnalytics.png'
import trafficBg from '../../styles/assets/dashboard/traffic_graph_bg.png'
import loadingIcon1 from '../../styles/assets/dashboard/loading1.svg'
import loadingIcon2 from '../../styles/assets/dashboard/loading2.svg'
import { Text } from '../../components/topography'
import { ExportButton } from '../../components/chartImageExport/exportButton'
import { LoadingWheel } from '../../components/loading/Loading'
import { NoDataDiv } from '../../components/tables/styled'
import GoogleSignIn, {
  GoogleButton,
  GoogleFont,
  GoogleIconWrapper,
} from '../../components/buttons/GoogleSignIn'
import { clearProjectHistoricSearchTraffic } from '../../utils/api'
import { OutlineButton } from '../../components/buttons/Buttons'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
} from '../../utils/kissmetrics'
import { formatNumber } from '../../utils/numbers'
import { getGoogleSignInURL } from '../../utils/consts.mjs'
import { clearGoogleStatus } from '../../utils/storage'
import { isSubUser } from '../../utils/userAuth'
import { Mixpanel, MIXPANEL_PROPS } from '../../utils/mixpanel'

export const DateRangeArea = styled.div({
  minHeight: '72px',
  margin: '0 calc(-2% - 44px)',
  padding: '8px calc(2% + 44px) 16px',
  background: palette.lightGray30,
  marginBottom: '32px',
  [mediaQueries.mobile]: {
    margin: '0 -15px 32px',
  },
})
export const RangeSection = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  flexWrap: 'wrap',
})

export const DateRangeSection = styled.div({
  display: 'flex',
  alignItems: 'center',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
  flexWrap: 'wrap',
})

export const FilterSection = styled.div({
  display: 'flex',
  alignItems: 'center',
})

export const ProjectSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
})

export const GraphSection = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    marginTop: '0px',
  },
})

export const GraphWrapper = styled.div(
  ({ clickable, width = '100%', hoverable = false, minHeight = 'auto' }) => ({
    cursor: clickable ? 'pointer' : 'auto',
    display: 'inline-flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    padding: '24px',
    width,
    position: 'relative',
    minHeight,
    marginTop: '24px',

    background: palette.white,
    border: `1px solid ${palette.lightGray}`,
    boxSizing: 'border-box',
    borderRadius: '2px',

    '& + &': {
      marginLeft: '30px',
    },

    '&:hover': hoverable
      ? {
          [mediaQueries.notMobile]: {
            color: `${palette.orange} !important`,
            backgroundColor: palette.white,
            boxShadow: shadows.shadowB,
            transform: 'scale(1.1)',
            zIndex: 99,
            borderLeft: 'none',
          },
        }
      : {
          [mediaQueries.notMobile]: {
            // color: `${palette.orange} !important`,
          },
        },
    '&:hover div span': {
      [mediaQueries.notMobile]: {
        // color: `${palette.orange} !important`,
      },
    },
    [mediaQueries.mobile]: {
      flexDirection: 'column !important',
      width: '100% !important',
      padding: '20px !important',
      borderBottom: `1px solid ${palette.lightGray50}`,
      margin: '16px 0 0 0 !important',
    },
  }),
)

export const GraphTitle = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  lineHeight: '16px',
  fontFamily: fonts.primaryBold,
}))

export const NoProjects = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  zIndex: 10,
  padding: 50,
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    padding: 15,
  },
  '& button': {
    maxWidth: 'initial',
    height: '50px',
    padding: '0 30px',
    fontSize: '13px',
    fontFamily: fonts.primaryMedium,
    borderRadius: '2px',
    borderColor: palette.orange,
  },
})

const SeeMoreText = styled.span(({ color }) => ({
  color: color || palette.darkGray,
  fontFamily: fonts.primaryBook,
  fontSize: '14px',
  lineHeight: '16px',
  width: 'fit-content',
  marginRight: 8,
}))

const SeeMoreContainer = styled.div(({ overrideStyles }) => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  marginTop: '10px',
  cursor: 'pointer',
  ...overrideStyles,
}))

export const NeilTipPanel = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  zIndex: 10,
  marginTop: '50px',
  marginLeft: '30px',
  [mediaQueries.mobile]: {
    alignItems: 'center',
    margin: '30px 0',
  },
})

export const NeilTip = styled.div({
  flex: 1,
  color: palette.darkGray,
  fontFamily: fonts.primaryLight,
  whiteSpace: 'pre-wrap',
  fontSize: '20px',
  lineHeight: '1.3em',
})

export const List = styled.ul({
  padding: 0,
  width: '100%',
  margin: '40px 0',
  listStyle: 'disc',
})

export const Item = styled.li({
  margin: '8px 0 8px 14px',
  fontSize: '16px',
  fontFamily: fonts.primaryLight,
  color: palette.darkGray,
})

const GraphHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
})

export const GraphPanel = ({
  title,
  description,
  subtitle,
  children,
  shouldDisplayDownloadButton,
  onClickDownloadbutton,
  isMobile,
  isLoading,
  hideDownloadButton = false,
  ...rest
}) => (
  <GraphWrapper {...rest} clickable>
    <GraphHeader>
      <GraphTitle>
        {title.toUpperCase()}
        {description && (
          <Tooltip
            id={title}
            text={description}
            style={{ marginLeft: '10px' }}
          />
        )}
      </GraphTitle>
      <Text fontSize="10px" lineHeight="12px" color={palette.gray}>
        {subtitle}
      </Text>
      {!hideDownloadButton && (
        <ExportButton
          shouldDisplayDownloadButton={shouldDisplayDownloadButton}
          onClick={() =>
            onClickDownloadbutton(
              <GraphTitle>{title.toUpperCase()}</GraphTitle>,
            )
          }
          disabled={isLoading}
          isLoading={isLoading}
          isMobile={isMobile}
        />
      )}
    </GraphHeader>
    {children}
  </GraphWrapper>
)

export const SeeMoreSection = ({
  text = undefined,
  disabled,
  onClick,
  style,
}) => {
  return (
    <SeeMoreContainer
      onClick={disabled ? () => ({}) : onClick}
      overrideStyles={style}
    >
      <SeeMoreText color={disabled ? palette.lightGray : palette.darkGray}>
        {text || translate('see_more')}
      </SeeMoreText>
      <Icon src={disabled ? arrowRightGray : arrowRight} />
    </SeeMoreContainer>
  )
}

export const CompetitorsSection = styled.div({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  marginLeft: '24px',
  alignItems: 'center',
  [mediaQueries.mobile]: {
    margin: '12px 0 0 0',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
})

export const ActionButtons = styled.div({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
})

export const LeftSide = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  flex: 1,
  justifyContent: 'flex-start',
  minWidth: '280px',
  [mediaQueries.smallDesktop]: {
    '& > button': {
      margin: '8px 0',
    },
  },
  [mediaQueries.mobile]: {
    '& > button': {
      margin: '8px 0',
    },
  },
})

export const Wrapper = styled.div({
  position: 'relative',
  display: 'inline',
})

export const SectionTitle = styled.span({
  fontFamily: fonts.primaryBold,
  textTransform: 'uppercase',
  color: palette.orange,
  fontWeight: 'bold',
  lineHeight: '40px',
  fontSize: 16,
})

export const SectionText = styled.span({
  whiteSpace: 'pre-wrap',
  fontWeight: '300',
  fontSize: 12,
  color: palette.darkGray,
  lineHeight: '20px',
  textTransform: 'none',
  '& > a': {
    textDecoration: 'underline',
    color: palette.orange,
    fontFamily: fonts.primaryBold,
  },
  '& b': {
    fontFamily: fonts.primaryBold,
  },
})

export const SubTextContainer = styled.span({
  fontSize: '14px',
  lineHeight: '14px',
  textTransform: 'initial',
  fontFamily: fonts.primaryBook,
  cursor: 'pointer',
  textDecoration: 'underline',
  [mediaQueries.mobile]: {
    marginTop: '5px',
    marginLeft: 0,
  },
})

export const Section = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '5px 10px 15px 0px',
  ':nth-child(2)': {
    paddingLeft: '20px',
  },
})

export const Opportunity = ({ title }) => {
  return (
    <div
      style={{
        margin: '0 0 24px 0',
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <Icon src={checkGreenIcon} size="16px" />
      <Text
        fontSize="12px"
        lineHeight="16px"
        margin="0 0 0 4px"
        boldColor={palette.darkGray}
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
    </div>
  )
}

const PositionWrapper = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  [mediaQueries.mobile]: {
    textAlign: 'center',
  },
})

export const ValueInfo = ({
  newValue,
  oldValue,
  change,
  reverse,
  inactive,
  format = (data) => formatNumber(data, false),
  valueFontSize,
  mobileValueFontSize,
  up,
  style,
  arrowColor,
  changeFontSize,
  mobileChangeFontSize,
  className = '',
}) => {
  const isUp =
    up ||
    (!isNaN(newValue) && newValue < oldValue) ||
    (!isNaN(newValue) && oldValue === null)

  return (
    <PositionWrapper style={style} className={className}>
      {!!change && oldValue && (
        <>
          <Text
            fontSize={valueFontSize || '14px'}
            mobileFontSize={mobileValueFontSize || '10px'}
            lineHeight="1.2em"
            color={inactive ? palette.lightGray : palette.gray}
            margin="0 5px 0 0"
            mobileMargin="0 2px 0 0"
          >
            {format(oldValue)}
          </Text>
          <Text
            fontSize={valueFontSize || '14px'}
            mobileFontSize={mobileValueFontSize || '10px'}
            lineHeight="1.2em"
            color={arrowColor || palette.gray}
            margin="0 5px 0 0"
            mobileMargin="0 2px 0 0"
          >
            →
          </Text>
        </>
      )}
      <Text
        fontSize={valueFontSize || '14px'}
        mobileFontSize={mobileValueFontSize || '10px'}
        lineHeight="1.2em"
        fontFamily={fonts.primaryMedium}
        margin="0 5px 0 0"
        mobileMargin="0 2px 0 0"
        color={inactive ? palette.gray : palette.darkGray}
      >
        {format(newValue)}
      </Text>
      {!!change && (
        <ArrowLabel
          small
          up={reverse ? !isUp : isUp}
          style={{ marginTop: '2px' }}
        />
      )}
      {!!change && (
        <Text
          fontSize={changeFontSize || '14px'}
          mobileFontSize={mobileChangeFontSize || '10px'}
          lineHeight="1.3em"
          color={inactive ? palette.gray : palette.darkGray}
        >
          {format(Math.round(Math.abs(change)))}
        </Text>
      )}
    </PositionWrapper>
  )
}

export const AnalyticsSection = styled.div({
  margin: '16px 0 0 0',
  display: 'flex',
  position: 'relative',
  height: '275px',
  flexDirection: 'column',
})

export const OverallStatus = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
})

const BlockWrapper = styled.div(
  ({ width, height, isPDFScreenshot, position }) => ({
    position: 'absolute',
    cursor: 'default !important',
    fontSize: 'inherit',
    color: `${palette.lightGray20} !important`,
    width: width || '100%',
    height: height || '80%',
    left: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: height === 'auto' || height > 800 ? 'flex-start' : 'center',
    zIndex: 100,

    ...(!isPDFScreenshot && {
      [mediaQueries.mobile]: {
        position: position || 'absolute',
        minWidth: '180px',
      },
    }),

    ...(isPDFScreenshot && {
      width: '800px',
      height: '150px',
      position: 'fixed',
      top: '-9999px',
      left: '-9999px',
    }),
  }),
)

const BlockContent = styled.div({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const BlurBackground = styled.div(({ enabled }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 10,
  left: 0,
  background: enabled ? palette.white : palette.transparent,
  zIndex: -1,
  boxShadow: enabled
    ? 'inset 1px -1px 90px 57px rgb(255 255 252 / 13%)'
    : 'none',
  backgroundImage: `url(${trafficBg})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
}))

export const GoogleServiceStatusWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  margin: '8px 0',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    margin: '8px 0 0 0',
  },
})

export const GABlockWrapper = ({
  project,
  openConnectGAModal,
  chartIsReady,
  setChartIsReady,
  isPDFScreenshot,
  estimatedOrganicChartRef,
  removeSuccessNotifications,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { googleServiceStatus } = project

  useEffect(() => {
    if (!isLoading && !chartIsReady && setChartIsReady) {
      setChartIsReady()
    }
  }, [isLoading, chartIsReady, setChartIsReady])

  const getGoogleButtonLabel = () => {
    if (isLoading) {
      return (
        <div style={{ paddingInline: 50 }}>
          <LoadingWheel color={palette.white} width="20px" height="20px" />
        </div>
      )
    }

    if (googleServiceStatus?.gsc?.status) {
      return translate('connect_with_ga')
    }

    return translate('connect_with_google')
  }

  const handleConnectWithGoogle = async () => {
    setIsLoading(true)

    kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.click_gsc, {
      domain: project.domain,
    })
    kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.click_ga, {
      domain: project.domain,
    })

    await Mixpanel.trackConnectWithGoogleToolsClick({
      buttonLocation:
        MIXPANEL_PROPS.CONNECT_WITH_GOOGLE_BUTTON_LOCATION.values.CHART,
    })

    setTimeout(() => {
      window.location.href = getGoogleSignInURL({
        next: `/${getLanguageCode()}/dashboard`,
        lang: getLanguageCode(),
        projectId: project.id,
        projectDomain: project.domain,
        gs: googleServiceStatus?.gsc?.status ? 'ga' : undefined,
      })
    }, 200)

    clearGoogleStatus(
      project.id,
      googleServiceStatus?.gsc?.status ? ['ga'] : ['ga', 'gsc'],
    )
    clearProjectHistoricSearchTraffic()
  }

  if (isPDFScreenshot) {
    if (removeSuccessNotifications) removeSuccessNotifications('success')
    return (
      <BlockWrapper
        ref={estimatedOrganicChartRef}
        isPDFScreenshot={isPDFScreenshot}
      >
        <BlurBackground enabled />
        <BlockContent
          style={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            boldColor={palette.darkGray}
            textAlign="center"
            dangerouslySetInnerHTML={{
              __html: googleServiceStatus?.gsc?.status
                ? translate('connect_ga_cta')
                : translate('connect_with_google_cta'),
            }}
            margin="0 0 16px 0"
          />
        </BlockContent>
      </BlockWrapper>
    )
  }

  const renderGoogleButton = () => {
    if (!googleServiceStatus) {
      if (removeSuccessNotifications) removeSuccessNotifications('success')
      return (
        <OutlineButton
          static
          style={{
            width: '200px',
            height: '40px',
            flex: 'inherit',
            fontSize: '12px',
            lineHeight: '18px',
            padding: '8px',
            color: palette.darkGray,
            border: `1px solid ${palette.lightGray50}`,
            marginRight: '8px',
            textTransform: 'none',
            fontFamily: fonts.primary,
            letterSpacing: 0,
          }}
          onClick={() => ({})}
          disabled={isSubUser()}
        >
          <LoadingWheel width="20px" height="20px" />
          {translate('connect_with_google')}
        </OutlineButton>
      )
    }

    if (googleServiceStatus?.ga?.error === 'missing_profile') {
      if (removeSuccessNotifications) removeSuccessNotifications('success')
      return (
        <GoogleButton
          onClick={() => {
            Mixpanel.trackConnectWithGoogleToolsClick({
              buttonLocation:
                MIXPANEL_PROPS.CONNECT_WITH_GOOGLE_BUTTON_LOCATION.values.CHART,
            })
            openConnectGAModal()
          }}
          height="40px"
          theme="dark"
          style={{ padding: '1px 0px', boxShadow: 'none' }}
          disabled={isSubUser()}
        >
          <GoogleIconWrapper>
            <Icon src={gaIcon} size="38px" />
          </GoogleIconWrapper>
          <GoogleFont mobileStretch>{translate('connect_with_ga')}</GoogleFont>
        </GoogleButton>
      )
    }

    return (
      <GoogleSignIn
        icon={
          googleServiceStatus?.gsc?.status ? (
            <Icon src={gaIcon} size="38px" />
          ) : null // use google icon if GSC is not connected too
        }
        label={getGoogleButtonLabel()}
        height="40px"
        theme="dark"
        style={{ height: '40px', boxShadow: 'none' }}
        useClickEvent
        onClick={handleConnectWithGoogle}
        disabled={isSubUser()}
      />
    )
  }

  if (removeSuccessNotifications) removeSuccessNotifications('success')

  return (
    <BlockWrapper>
      <BlurBackground enabled />
      <BlockContent
        style={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text
          boldColor={palette.darkGray}
          textAlign="center"
          dangerouslySetInnerHTML={{
            __html: googleServiceStatus?.gsc?.status
              ? translate('connect_ga_cta')
              : translate('connect_with_google_cta'),
          }}
          margin="0 0 16px 0"
        />
        {renderGoogleButton()}
      </BlockContent>
    </BlockWrapper>
  )
}

export const StatusSection = styled.div((props) => ({
  width: props.width || '100%',
  padding: props.padding || '0',
  [mediaQueries.mobile]: {
    width: '100%',
  },
}))

export const LoadingSeoOpportunities = ({ start, step }) => {
  const [counter, setCounter] = useState(start)
  useEffect(() => {
    setTimeout(() => setCounter(counter + step), 2000)
  })

  return (
    <NoDataDiv
      height={220}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        background: palette.transparent,
        alignItems: 'center',
      }}
    >
      <div style={{ position: 'relative' }}>
        <ReactLoading
          type="spin"
          delay={0}
          color={palette.orange}
          height={90}
          width={90}
        />
        {counter % 2 ? (
          <Icon
            src={loadingIcon1}
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        ) : (
          <Icon
            src={loadingIcon2}
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        )}
      </div>
      <Text
        fontSize="20px"
        lineHeight="20px"
        textAlign="center"
        margin="0 0 0 24px"
        fontFamily={fonts.primaryBook}
      >
        {translate('seo_opportunities_loading_heading')}
      </Text>
    </NoDataDiv>
  )
}

export const OpportunityArea = styled.div({
  display: 'flex',
  width: '100%',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})
